(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvLinkedEntityPreview', function () {
            return {
                templateUrl: 'app/entity/linked-entity-preview.tmpl.html',
                scope: {
                    value: '=ngModel'
                },
                controller: ['$scope', 'EntitiesService', 'DialogService', function ($scope, EntitiesService, DialogService) {
                    var drvCtrl = this;
                    drvCtrl.loadEntity = loadEntity;

                    activate();

                    function activate() {
                    }

                    function loadEntity() {
                        if (loadEntity.currentPromise === undefined) {
                            loadEntity.currentPromise = null;
                        }
                        var getPromise = EntitiesService.get(drvCtrl.value)
                        .then(getEntityOk, getEntityError);

                        loadEntity.currentPromise = getPromise;

                        return getPromise;

                        function getEntityOk(data) {
                            if (getPromise === loadEntity.currentPromise) {
                                drvCtrl.entity = angular.copy(data);
                            }
                        }

                        function getEntityError(response) {
                            if (getPromise === loadEntity.currentPromise) {
                                DialogService.error('Error fetching Entity', response);
                            }
                        }
                    }

                    $scope.$watch(function () {
                        return drvCtrl.value;
                    }, function () {
                        if (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== '') {
                            drvCtrl.loadEntity();
                        }
                    });
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel'
                }
            };
        });
})();